// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Button, TableCell, TableRow, TextField } from '@mui/material'
import React from 'react'
import { Mutation } from 'react-apollo'
import { i18n } from '../../../index'
import { updateChainSettings } from './chainSettingsQueries'
import css from './chainSettingsRow.css'

const defaultFormData = {
  value: '',
}

type Props = any

type FormData = {
  value: string
}

type State = {
  formData: FormData
}

export default class ChainSettingsRow extends React.PureComponent<Props, State> {
  state = {
    editing: false,
    formData: {
      ...defaultFormData,
    },
  }

  componentDidMount() {
    const { data } = this.props

    if (data) {
      this.setStateFromData(data)
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { data } = this.props

    if (data && JSON.stringify(data) !== JSON.stringify(prevProps.data)) {
      this.setStateFromData(data)
    }
  }

  setStateFromData = (data: any) => {
    this.setState({
      formData: {
        ...defaultFormData,
        id: data.id,
        name: data.name,
        value: data.value,
      },
    })
  }

  handleCancel = () => {
    return this.setState({ editing: false })
  }

  onInput = (fieldName: string, newValue: (string | null | undefined) | number) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [fieldName]: newValue,
      },
    })
  }

  submit = (mutate: any) => async () => {
    if (!this.state.editing) {
      return this.setState({ editing: true })
    }

    const formData = {
      ...this.state.formData,
    }

    const payload = {
      variables: {
        id: formData.id,
        value: formData.value,
      },
    }
    await mutate(payload)

    return this.setState({
      editing: false,
      upstream: this.state.editable,
    })
  }

  render() {
    const { data } = this.props
    const { editing, formData } = this.state
    return (
      <Mutation mutation={updateChainSettings} fetchPolicy='network-only'>
        {(mutate, { loading }) => (
          <React.Fragment>
            <TableRow key={data.key} className={css.tableRow}>
              <TableCell>
                <span>{data.name}</span>
              </TableCell>
              <TableCell>
                <TextField
                  type='number'
                  name='settingValue'
                  value={formData.value}
                  onChange={(e) => this.onInput('value', e.target.value)}
                  disabled={!editing}
                />
              </TableCell>
              <TableCell className={css.actions}>
                {editing && (
                  <Button
                    style={{ marginRight: `10px` }}
                    variant='contained'
                    color='secondary'
                    onClick={this.handleCancel}
                  >
                    {i18n.t('buttons.cancel')}
                  </Button>
                )}
                <Button
                  variant='contained'
                  disabled={loading}
                  color='primary'
                  type='submit'
                  onClick={this.submit(mutate)}
                >
                  {loading ? 'Lataa...' : editing ? i18n.t('buttons.save') : i18n.t('buttons.edit')}
                </Button>
              </TableCell>
            </TableRow>
          </React.Fragment>
        )}
      </Mutation>
    )
  }
}
